import { render, staticRenderFns } from "./CountryRegion.vue?vue&type=template&id=66f1197a&scoped=true&"
import script from "./CountryRegion.vue?vue&type=script&lang=js&"
export * from "./CountryRegion.vue?vue&type=script&lang=js&"
import style0 from "./CountryRegion.vue?vue&type=style&index=0&id=66f1197a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1197a",
  null
  
)

export default component.exports